<template>
  <div class="sign-up-container">
    <b-card class="sign-up-card col-sm-8 col-md-8 col-lg-6">
      <b-row>
        <b-col class="col-1">
          <b-img :src="require('./../assets/stuff_to_do_logo.png')" class="logo"></b-img>
        </b-col>
        <b-col>
          <span class="app-name-text">Stuff To-Do</span>
        </b-col>
      </b-row>

      <h1 class="card-title">Sign up</h1>

      <div class="profile-picture-section">
        <b-row>
          <b-col>
            <b-img v-if="profilePictureUrl" class="profile-picture" :src="profilePictureUrl" rounded="circle"
                   alt="User profile picture"></b-img>

            <b-img v-else class="profile-picture" :src="require('../assets/default_profile.png')" rounded="circle"
                   alt="Circle image"></b-img>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="secondary-input-button" v-b-modal.sign-up-profile-picture-modal>Update profile picture</b-button>
          </b-col>
        </b-row>
      </div>

      <div class="input-container">
        <b-row>
          <b-col>
            <label class="input-title">Full name</label>
            <b-form-input
                type="text"
                :state="informationValidation.isFullNameProvided"
                v-model="fullName"></b-form-input>

            <b-form-invalid-feedback v-if="!informationValidation.isFullNameProvided">
              This field must not be empty.
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </div>
      <div class="input-container">
        <b-row>
          <b-col>
            <label class="input-title">Email</label>
            <b-form-input
                type="email"
                :state="informationValidation.isEmailProvided && informationValidation.isEmailValid"
                v-model="email"></b-form-input>

            <b-form-invalid-feedback v-if="!informationValidation.isEmailProvided">
              This field must not be empty.
            </b-form-invalid-feedback>

            <b-form-invalid-feedback v-if="!informationValidation.isEmailValid">
              Please provide a valid email address.
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </div>
      <div class="input-container">
        <b-row>
          <b-col>
            <label class="input-title">Password</label>
            <b-form-input
                type="password"
                :state="informationValidation.isPasswordValid"
                v-model="password"></b-form-input>

            <b-form-invalid-feedback v-if="!informationValidation.isPasswordValid">
              The password must be at least 6 characters long.
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </div>
      <div class="input-container">
        <b-row>
          <b-col>
            <label class="input-title">Confirm password</label>
            <b-form-input
                type="password"
                :state="informationValidation.isConfirmPasswordValid"
                @blur="$v.confirmPassword.$touch()"
                v-model="confirmPassword"></b-form-input>

            <b-form-invalid-feedback v-if="!informationValidation.isConfirmPasswordValid">
              The password does not match.
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </div>

      <b-button block class="sign-up-button" @click="navigateToHomePage">Sign up</b-button>

      <b-row>
        <b-col>
          <p class="sign-in-option-text">Already have an account? <span class="sign-in-text"
                                                                        @click="navigateToSignInPage">Sign in</span></p>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
        id="loading-modal"
        size="sm"
        centered
        no-close-on-backdrop
        hide-header
        hide-footer>
      <img
          width="265px"
          class="center-image"
          src="../assets/animated_loading.gif"
          alt="loading animation">
    </b-modal>

    <!-- Sign up profile picture modals -->
    <b-modal id="sign-up-profile-picture-modal"
             title="Update Profile Picture"
             hide-footer
             no-close-on-backdrop>
      <input type="file" accept="image/*" @change="onFileChange" id="profile-picture-input"/>

      <div id="preview">
        <img v-if="profilePictureUrl" :src="profilePictureUrl"/>
      </div>
      <b-button variant="outline-danger" class="remove-profile-picture-button" :disabled="!profilePictureUrl" block @click="removeProfilePicture">
        Remove profile picture
      </b-button>
    </b-modal>
  </div>
</template>

<script>
  import {required, email, minLength, sameAs} from 'vuelidate/lib/validators'

  export default {
    data() {
      return {
        fullName: '',
        email: '',
        password: '',
        confirmPassword: '',
        profilePictureUrl: null,
        profilePictureFile: null,
        informationValidation: {
          isFullNameProvided: null,
          isEmailProvided: null,
          isEmailValid: null,
          isPasswordValid: null,
          isConfirmPasswordValid: null
        }
      }
    },
    validations: {
      fullName: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLen: minLength(6)
      },
      confirmPassword: {
        required,
        sameAs: sameAs('password')
      }
    },
    methods: {
      onFileChange(e) {
        this.profilePictureFile = e.target.files[0];

        if (this.profilePictureFile !== undefined) {
          this.profilePictureUrl = URL.createObjectURL(this.profilePictureFile);
        } else {
          this.profilePictureUrl = null
        }
      },
      removeProfilePicture() {
        // remove the profile picture
        this.profilePictureFile = null
        this.profilePictureUrl = null
        document.getElementById("profile-picture-input").value = "";

        this.hideModal('account-details-profile-picture-modal')
      },
      navigateToHomePage() {
        // check if all information is valid
        let isValid = true

        if (!this.$v.fullName.required) {
          this.informationValidation.isFullNameProvided = false
          isValid = false
        } else {
          this.informationValidation.isFullNameProvided = true
        }

        if (!this.$v.email.required) {
          this.informationValidation.isEmailProvided = false
          isValid = false
        } else {
          this.informationValidation.isEmailProvided = true
        }

        if (!this.$v.email.email) {
          this.informationValidation.isEmailValid = false
          isValid = false
        } else {
          this.informationValidation.isEmailValid = true
        }

        if (!this.$v.password.required || !this.$v.password.minLen) {
          this.informationValidation.isPasswordValid = false
          isValid = false
        } else {
          this.informationValidation.isPasswordValid = true
        }

        if (!this.$v.confirmPassword.required || this.$v.confirmPassword.$error) {
          this.informationValidation.isConfirmPasswordValid = false
          isValid = false
        } else {
          this.informationValidation.isConfirmPasswordValid = true
        }

        if (isValid) {
          const userData = {
            email: this.email,
            name: this.fullName,
            password: this.password,
            profilePictureFile: this.profilePictureFile
          }
          this.$store.dispatch('signUp', userData)
        }
      },
      navigateToSignInPage() {
        this.$router.push({name: 'Sign In'})
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    }
  }
</script>

<style scoped>
  .profile-picture-section {
    text-align: center;
  }

  .profile-picture {
    width: 12em;
    height: 12em;
    margin-bottom: 1em;
  }

  #preview {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #preview img {
    max-width: 100%;
    max-height: 500px;
  }

  .current-profile-picture-text {
    text-align: center;
    margin-top: 1em;
  }

  .center-image {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .sign-up-container {
    width: 80%;
    margin: 0 auto;
  }

  .logo {
    width: 2em;
  }

  .sign-up-card {
    margin: 2em auto;
  }

  .app-name-text {
    font-size: 1.2em;
    font-weight: bold;
    color: #212441;
  }

  .card-title {
    font-size: 2em;
  }

  .input-container {
    margin: 1em 0;
  }

  .input-title {
    font-weight: bold;
  }

  .remove-profile-picture-button {
    margin-top: 1em;
  }

  .secondary-input-button {
    background-color: white;
    color: #212441;
    padding: 0.5em;
  }

  .secondary-input-button:hover {
    background-color: #212441;
    color: white;
    padding: 0.5em;
  }

  .sign-up-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .sign-up-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }

  .sign-in-option-text {
    text-align: center;
    margin-top: 1em;
    margin-bottom: 0;
  }

  .sign-in-text {
    color: #212441;
    font-weight: bold;
  }

  .sign-in-text:hover {
    color: #212441;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }

  .warning-text {
    margin-bottom: 0;
    color: red;
  }

</style>
